import { render } from "./ProductCreate.vue?vue&type=template&id=339dfb76"
import script from "./ProductCreate.vue?vue&type=script&lang=js"
export * from "./ProductCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__